export default __webpack_public_path__ + "static/media/insta.c726de72.png";